import type { OrderStatus, PaymentStatus } from '@oficina/shared';

/** Cores dos badges de status — as mesmas do protótipo. */
export const STATUS_STYLE: Record<OrderStatus, { bg: string; fg: string }> = {
  AGUARDANDO: { bg: '#f0f2f2', fg: '#697679' },
  DIAGNOSTICO: { bg: '#eaf0ff', fg: '#3559a7' },
  AGUARDANDO_APROVACAO: { bg: '#f3e8ff', fg: '#7e22ce' },
  APROVADO: { bg: '#fff3d6', fg: '#9c6910' },
  REPARO: { bg: '#e8f4ff', fg: '#2874a4' },
  AGUARDANDO_PECA: { bg: '#fff1e8', fg: '#b45b20' },
  CONCLUIDO: { bg: '#e4f4ed', fg: '#17785f' },
  ENTREGUE: { bg: '#edf0f0', fg: '#617074' },
  CANCELADO: { bg: '#fff0ee', fg: '#ba4d45' },
  NAO_APROVADO: { bg: '#f5ecec', fg: '#8a5a5a' },
  SEM_REPARO: { bg: '#fffaeb', fg: '#9a7a1f' },
};

export const PAYMENT_STYLE: Record<PaymentStatus, { bg: string; fg: string }> = {
  PENDENTE: { bg: '#fff3d6', fg: '#9c6910' },
  PARCIAL: { bg: '#eaf0ff', fg: '#3559a7' },
  PAGO: { bg: '#e4f4ed', fg: '#17785f' },
};
